import axios from 'axios';
import { url } from '../../client_config/config';

const state = {
  unreadCount: 0,
  unreadThreadCount: 0
};

const mutations = {
  SET_UNREAD_COUNT(state, { unreadCount = 0, unreadThreadCount = 0 }) {
    state.unreadCount = Math.max(0, Number(unreadCount) || 0);
    state.unreadThreadCount = Math.max(0, Number(unreadThreadCount) || 0);
  },
  INCREMENT_UNREAD_COUNT(state, by = 1) {
    state.unreadCount = Math.max(0, state.unreadCount + (Number(by) || 0));
  },
  RESET_UNREAD(state) {
    state.unreadCount = 0;
    state.unreadThreadCount = 0;
  }
};

const actions = {
  async fetchUnreadCount({ commit, rootState }) {
    const token = rootState.auth?.token || localStorage.getItem('token');
    if (!token) {
      commit('RESET_UNREAD');
      return { unreadCount: 0, unreadThreadCount: 0 };
    }

    try {
      const response = await axios.get(`${url}/chat/unread-count`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const unreadCount = response.data?.unreadCount || 0;
      const unreadThreadCount = response.data?.unreadThreadCount || 0;
      commit('SET_UNREAD_COUNT', { unreadCount, unreadThreadCount });
      return { unreadCount, unreadThreadCount };
    } catch (error) {
      console.error('Error fetching chat unread count:', error);
      return null;
    }
  },

  bumpUnread({ commit }, by = 1) {
    commit('INCREMENT_UNREAD_COUNT', by);
  },

  clearUnread({ commit }) {
    commit('RESET_UNREAD');
  }
};

const getters = {
  chatUnreadCount: (state) => state.unreadCount,
  chatUnreadThreadCount: (state) => state.unreadThreadCount
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
